module.exports = __webpack_public_path__ + "static/media/acces-executif.d4b91823.svg";